import Vue from 'vue'
import VueRouter from 'vue-router'
import navguard from '@/router/navguard.js'
import store from '@/store'

// import HomeView from '../views/HomeView.vue'

const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
};

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/login.vue'),
    meta : {
      group : ['public']
    }
  },
  {
    path: '/forgotpassword',
    name: 'forgotPassword',
    component: () => import('../views/forgotPassword.vue'),
    meta : {
      group : ['public']
    }
  },
  {
    path: '/reset-password',
    name: 'resetPassword',
    component: () => import('../views/resetPassword.vue'),
    meta : {
      group : ['public']
    }
  },
  {
    path: '/set-password',
    name: 'setPassword',
    component: () => import('../views/setPassword.vue'),
    meta : {
      group : ['public']
    }
  },
  {
    path: '/',
    component: () => import('../views/dashboardMain.vue'),
    children : [
      {
        path: '',
        name: 'dashboard',
        component: () => import('../views/dashboard.vue'),
        meta : {
          pageGroup: 'dashboard',
          group    : ['geneva']
        },
      },
      {
        path: 'goal/:id',
        name: 'goalView',
        component: () => import('../views/goalView.vue'),
        meta : {
          pageGroup: 'dashboard',
          group    : ['geneva'],
          roles    : ['subscriber']
        },
      },
      {
        path: 'admindashboard',
        name: 'adminDashboard',
        component: () => import('../views/adminDashboard.vue'),
        meta : {
          pageGroup: 'adminDashboard',
          group    : ['geneva'],
          roles    : ['admin']
        },
      },
      {
        path: 'analytics/meetingattendance',
        name: 'adminAnalyticsAttendance',
        component: () => import('../views/adminAnalyticsAttendance.vue'),
        meta : {
          pageGroup: 'adminDashboard',
          group    : ['geneva'],
          roles    : ['admin']
        },
      },
      {
        path: 'analytics/meetingattendance/ward/:ward',
        name: 'adminAnalyticsAttendanceWard',
        component: () => import('../views/adminAnalyticsAttendanceWard.vue'),
        meta : {
          pageGroup: 'adminDashboard',
          group    : ['geneva'],
          roles    : ['admin']
        },
      },
      {
        path: 'analytics/tasks',
        name: 'adminAnalyticsTasks',
        component: () => import('../views/adminAnalyticsTask.vue'),
        meta : {
          pageGroup: 'adminDashboard',
          group    : ['geneva'],
          roles    : ['admin']
        },
      },
      {
        path: 'analytics/tasksbyward',
        name: 'adminAnalyticsTasksByWard',
        component: () => import('../views/adminAnalyticsTask.vue'),
        meta : {
          pageGroup: 'adminDashboard',
          group    : ['geneva'],
          roles    : ['admin']
        },
      },
      {
        path: 'analytics/goal',
        name: 'adminAnalyticsGoal',
        component: () => import('../views/adminAnalyticsGoal.vue'),
        meta : {
          pageGroup: 'adminDashboard',
          group    : ['geneva'],
          roles    : ['admin']
        },
      },
      {
        path: 'analytics/goal/:id',
        name: 'adminAnalyticsGoalView',
        component: () => import('../views/goalView.vue'),
        meta : {
          pageGroup: 'adminDashboard',
          group    : ['geneva'],
          roles    : ['admin']
        },
        
      },
      
    ]
  },
  {
    path: '/directory',
    name: 'directory',
    component: () => import('../views/directory.vue'),
    meta : {
      pageGroup: 'directory',
      group    : ['geneva']
    }
  },
  {
    path: '/wards',
    name: 'wards',
    component: () => import('../views/wards.vue'),
    meta : {
      pageGroup: 'wards',
      group    : ['geneva']
    }
  },
  {
    path: '/knowledgebase',
    component: () => import('../views/knowledgeMain.vue'),
    children : [
      {
        path: '/',
        name: 'knowledge-base',
        component: () => import('../views/knowledgeList.vue'),
        meta : {
          pageGroup: 'knowledge-base',
          group    : ['geneva']
        }
      },
      {
        path: '/sub/:slug',
        name: 'knoledgeSubs',
        component: () => import('../views/knowledgeSubList.vue'),
        meta : {
          pageGroup: 'knowledge-base',
          group    : ['geneva']
        }
      },
      {
        path: '/list/:slug',
        name: 'knowledgeSubKnowledges',
        component: () => import('../views/knowledgeSubKnowledges.vue'),
        meta : {
          pageGroup: 'knowledge-base',
          group    : ['geneva']
        }
      },
      {
        path: '/view/:slug/:id',
        name: 'knowledgeView',
        component: () => import('../views/knowledgebase.vue'),
        meta : {
          pageGroup: 'knowledge-base',
          group    : ['geneva']
        }
      },
    ]
  },
  {
    path: '/stakecalendar',
    component: () => import('../views/stakeCalendarMain.vue'),
    children : [
      {
        path: '',
        name: 'stakeCalendar',
        component: () => import('../views/stakeCalendar.vue'),
        meta : {
          pageGroup: 'stakeCalendar',
          group    : ['geneva']
        }
      },
      {
        path: 'view/:id',
        name: 'stakeCalendarEventDetails',
        component: () => import('../views/eventDetails.vue'),
        meta : {
          pageGroup: 'stakeCalendar',
          group    : ['geneva']
        }
      },
      {
        path: 'admin/view',
        name: 'stakeCalendarEventAdminDetails',
        component: () => import('../views/adminEventDetails.vue'),
        meta : {
          pageGroup: 'stakeCalendar',
          group    : ['geneva'],
          roles    : ['admin']
        }
      }
    ]
  },
  {
    path: '/settings',
    component: () => import('../views/settingsMain.vue'),
    children : [
      {
        path: '',
        name: 'settings',
        component: () => import('../views/settings.vue'),
        meta : {
          pageGroup: 'settings',
          group    : ['geneva']
        }
      },
      {
        path : 'users',
        name : 'users',
        component: () => import('../views/users.vue'),
        meta : {
          pageGroup: 'settings',
          group    : ['geneva'],
          roles    : ['admin']
        }
      }
    ]
  },
  {
    path: '/map',
    name: 'map',
    component: () => import('../views/map.vue'),
    meta : {
      pageGroup: 'map',
      group    : ['geneva']
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

//NAVIGATION GUARD CHECKER

router.beforeEach( async (to, from, next) => {
  return navguard({to, from, next, store});
});


export default router
